import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class StatisticsService {

  constructor(private http: HttpClient) {}
  private baseUrl = environment.beServiceUrl + '/v1/statistics';

getStats(request: any): Observable<{ totals: any; values: any[]; }> {
        return this.http.post<any>(
      this.baseUrl,
      request
    );
  }

getStatsEntity(request: any): Observable<{ totals: any; values: any[]; }> {
        return this.http.post<any>(
      this.baseUrl + '/entity',
      request
    );
}

getStatsEntityManage(request: any): Observable<{ totals: any; values: any[]; }> {
        return this.http.post<any>(
      this.baseUrl + '/entity-manage',
      request
    );
}

  getMockedStats(filters: {
    startDate?: string;
    endDate?: string;
  }): Observable<any[]> {
    const params: any = {};
    if (filters.startDate) params.startDate = filters.startDate;
    if (filters.endDate) params.endDate = filters.endDate;

    return of([
      {
        setting: 'ADI + Domicilio',
        reg_pra: 2957,
        reg_paz: 2594,
        asl_1_pra: 738,
        asl_1_paz: 675,
        asl_2_pra: 453,
        asl_2_paz: 411,
        asl_3_pra: 611,
        asl_3_paz: 566,
        asl_4_pra: 1155,
        asl_4_paz: 970,
      },
      {
        setting: 'Hospice e Cure Palliative',
        reg_pra: 68,
        reg_paz: 65,
        asl_1_pra: 1,
        asl_1_paz: 1,
        asl_2_pra: 16,
        asl_2_paz: 16,
        asl_3_pra: 51,
        asl_3_paz: 48,
      },
      {
        setting: 'Ospedale di comunità',
        reg_pra: 206,
        reg_paz: 194,
        asl_1_pra: 20,
        asl_1_paz: 20,
        asl_2_pra: 186,
        asl_2_paz: 174,
      },
      {
        setting: 'Residenza Protetta (RP)',
        reg_pra: 28,
        reg_paz: 27,
        asl_1_pra: 6,
        asl_1_paz: 6,
        asl_2_pra: 3,
        asl_2_paz: 3,
        asl_3_pra: 12,
        asl_3_paz: 12,
        asl_4_pra: 7,
        asl_4_paz: 6,
      },
      {
        setting: 'Residenza sanitaria assistenziale (RSA)',
        reg_pra: 482,
        reg_paz: 436,
        asl_1_pra: 110,
        asl_1_paz: 102,
        asl_2_pra: 96,
        asl_2_paz: 91,
        asl_3_pra: 169,
        asl_3_paz: 151,
        asl_4_pra: 107,
        asl_4_paz: 93,
      },
      {
        setting: 'Riabilitazione (ex art. 26)',
        reg_pra: 350,
        reg_paz: 321,
        asl_1_pra: 88,
        asl_1_paz: 82,
        asl_2_pra: 87,
        asl_2_paz: 80,
        asl_3_pra: 115,
        asl_3_paz: 105,
        asl_4_pra: 60,
        asl_4_paz: 57,
      },
      {
        setting: 'Post Acuzie cod.28',
        reg_pra: 0,
        reg_paz: 0,
      },
      {
        setting: 'Post Acuzie cod.56',
        reg_pra: 4,
        reg_paz: 4,
        asl_1_pra: 3,
        asl_1_paz: 3,
        asl_2_pra: 1,
        asl_2_paz: 1,
      },
      {
        setting: 'Post Acuzie cod.60',
        reg_pra: 0,
        reg_paz: 0,
      },
      {
        setting: 'Post Acuzie cod.75',
        reg_pra: 0,
        reg_paz: 0,
      },
      {
        setting: 'altro',
        reg_pra: 414,
        reg_paz: 387,
        asl_1_pra: 61,
        asl_1_paz: 56,
        asl_2_pra: 16,
        asl_2_paz: 16,
        asl_3_pra: 20,
        asl_3_paz: 19,
        asl_4_pra: 317,
        asl_4_paz: 296,
      },
    ]);
  }
}
